import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { reportClientError } from "../lib/errorReporting";

export class AppErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { reportClientError(error, "react-crash"); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="crm-crash-fallback">
      <div className="max-w-md space-y-5">
        <AlertTriangle size={36} className="text-amber-600" />
        <h1 className="font-head font-bold text-2xl" data-testid="crm-crash-heading">This page encountered an error</h1>
        <p className="text-muted-foreground" data-testid="crm-crash-message">An error report will be sent when a connection is available. Unsaved changes may need to be entered again.</p>
        <button onClick={() => window.location.reload()} data-testid="crm-crash-reload" className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity"><RefreshCw size={16} /> Reload page</button>
        <a href="/app" data-testid="crm-crash-home" className="block underline text-primary">Return to CRM</a>
      </div>
    </main>;
  }
}